import React, { useState } from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';

interface CollapsibleSectionProps {
  label: string;
  triggerCount: number;
  groupCount?: number;
  badgeColor?: string;
  defaultOpen?: boolean;
  children: React.ReactNode;
}

const CollapsibleSection: React.FC<CollapsibleSectionProps> = ({
  label,
  triggerCount,
  groupCount,
  badgeColor = 'bg-gray-100 text-gray-600',
  defaultOpen,
  children,
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen ?? triggerCount === 0);

  return (
    <div className="mb-4">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 w-full text-left py-2 group"
      >
        {isOpen ? (
          <ChevronDown className="w-4 h-4 text-gray-400" />
        ) : (
          <ChevronRight className="w-4 h-4 text-gray-400" />
        )}
        <span className="text-sm font-semibold text-gray-900">{label}</span>
        {triggerCount > 0 && (
          <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${badgeColor}`}>
            {triggerCount} trigger{triggerCount !== 1 ? 's' : ''}
            {groupCount != null && groupCount > 0 ? `, ${groupCount} item${groupCount !== 1 ? 's' : ''}` : ''}
          </span>
        )}
      </button>
      {isOpen && <div className="ml-6 mt-1">{children}</div>}
    </div>
  );
};

export default CollapsibleSection;
